//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQDefaultState from "@/components/Generics/AQDefaultState/AQDefaultState.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";

export default {
    name: "ViewAQDefaultState",
    components: {
        AQDefaultState,
        AQInput,
        AQToggle
    },
    data() {
        return {
            showCustomContent: false,
            defaultStateData: {
                title: "",
                description: ""
            },
            customStateData: {
                title: "Custom Title",
                description: "Custom Description"
            }
        };
    }
};
